import { UseMutationOptions } from '@tanstack/react-query';
import {
  UsePutParams,
  usePut as usePutAmcLink,
} from '@maiia/model/generated/model/api-patient/hooks/patAmcLink';
import { PatUserDTO } from '@maiia/model/generated/model/api-patient/api-patient';
import { AxiosError } from 'axios';
import { analyticsEvent } from '@/src/analytic_tag_manager';

type Error = {
  code: 'AMC_DATA_ALREADY_EXISTS' | string;
  message: string;
  requestId: string;
  subCodes: string[];
  timestamp: string;
};

type AmcDataContext = {
  amcNumber?: string;
  csr?: string;
  conventionType?: string;
};

const useCreateInsuranceContract = (
  options?: Omit<
    UseMutationOptions<
      PatUserDTO,
      AxiosError<Error>,
      UsePutParams,
      AmcDataContext
    >,
    'mutationFn'
  >,
) => {
  const { onSuccess, onError, ...restOptions } = options || {};

  const mutation = usePutAmcLink<AxiosError<Error>, AmcDataContext>({
    onError(error, variables, context) {
      const result = [
        context?.amcNumber,
        context?.conventionType,
        context?.csr,
        error.response?.data.message,
      ].join('-');
      analyticsEvent({
        category: 'IDB',
        action: 'IDBFail',
        label: result,
      });
      onError?.(error, variables, context);
    },
    onSuccess: async (data, variables, context) => {
      const result = [
        context?.amcNumber,
        context?.conventionType,
        context?.csr,
      ].join('-');
      analyticsEvent({
        category: 'IDB',
        action: 'IDBSuccessfull',
        label: result,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });

  return mutation;
};

export default useCreateInsuranceContract;
